import { Link } from "react-router-dom";
import { siteConfig, categoryList } from "@/mocks/siteConfig";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 text-lg font-bold mb-4 whitespace-nowrap"
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-white text-foreground-950 text-sm font-bold">
                M
              </span>
              {siteConfig.name}
            </Link>
            <p className="text-sm text-white/60 leading-relaxed">
              {siteConfig.description}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">
              <a href="/category/tutorial" className="hover:text-white/80 transition-colors">内容分类</a>
            </h4>
            <ul className="flex flex-col gap-2">
              {categoryList.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-white/60 hover:text-white/80 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-white/60 hover:text-white/80 transition-colors whitespace-nowrap"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-white/60 hover:text-white/80 transition-colors whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/category/tutorial"
                  className="text-sm text-white/60 hover:text-white/80 transition-colors whitespace-nowrap"
                >
                  使用教程
                </Link>
              </li>
              <li>
                <Link
                  to="/category/updates"
                  className="text-sm text-white/60 hover:text-white/80 transition-colors whitespace-nowrap"
                >
                  最新版本
                </Link>
              </li>
              <li>
                <Link
                  to="/category/download"
                  className="text-sm text-white/60 hover:text-white/80 transition-colors whitespace-nowrap"
                >
                  下载指南
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">联系我们</h4>
            <ul className="flex flex-col gap-2">
              <li className="text-sm text-white/60">
                <i className="ri-mail-line mr-2" />
                {siteConfig.email}
              </li>
              <li className="text-sm text-white/60">
                <i className="ri-phone-line mr-2" />
                {siteConfig.phone}
              </li>
              <li className="text-sm text-white/60">
                <i className="ri-map-pin-line mr-2" />
                {siteConfig.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/40">
            &copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href={siteConfig.social.weibo}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
              aria-label="微博"
            >
              <i className="ri-weibo-line text-sm" />
            </a>
            <a
              href={siteConfig.social.zhihu}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
              aria-label="知乎"
            >
              <i className="ri-zhihu-line text-sm" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}